import tippy from 'tippy.js';
import Cookies from 'js-cookie';
import randomId from 'javascripts/utils/random-id';
import { toggleCollapse } from 'javascripts/utils/collapse';
import { t } from 'javascripts/utils/withTranslation';

export default class Overlay {
  constructor(config) {
    this.config = {
      ...config,
    };
    this.hasGlobalConsent = false;
    this.cookieName = this.config.consentCookieName;
    this.$el = this.config.$el;
    this.$checkbox = this.$el.querySelector('.checkbox__input');
    this.$template = this.$el.querySelector('.js-overlay-template');
    this.smallOverlay = false;

    if (this.getConsentCookie(this.cookieName) === 'accept') {
      this.hasGlobalConsent = true;
    }

    window.addEventListener('resize', () => {
      this.detectOverlayWidth();
    });
    window.addEventListener('selectTab', () => {
      this.detectOverlayWidth();
    });

    this.detectOverlayWidth();
  }

  detectOverlayWidth = () => {
    if (
      (this.config.$el.offsetHeight * this.config.$el.offsetWidth) / 1000 <
      150
    ) {
      this.smallOverlay = true;
    } else {
      this.smallOverlay = false;
    }
  };

  setOverlaySize = () => {
    const $overlay = this.$el.querySelector('.overlay');
    const $headline = this.$el.querySelector('.overlay__headline');
    const $trigger = document.createElement('button');

    if (this.smallOverlay) {
      if (!$overlay) {
        return;
      }
      $overlay.classList.add('overlay--mini');
      const $tooltipText = this.$el.querySelector('.overlay__text');

      const controlId = `overlay--${randomId()}`;

      $trigger.innerHTML = $headline.innerHTML;
      $headline.parentNode.replaceChild($trigger, $headline);
      $trigger.setAttribute('class', 'icon-link overlay__headline');
      $trigger.setAttribute('aria-controls', controlId);
      $trigger.setAttribute('aria-expanded', 'false');
      $trigger.setAttribute('type', 'button');
      $tooltipText.setAttribute('id', controlId);
      $tooltipText.setAttribute('aria-hidden', true);

      $trigger?.addEventListener('click', (event) => {
        toggleCollapse($trigger, {
          addCloseButton: true,
        });
      });
    } else {
      $overlay?.classList.remove('overlay--mini');
      const p = document.createElement('p');
      p.classList.add('overlay__headline');
      p.innerHTML = $headline?.innerHTML;
      $headline?.parentNode?.replaceChild(p, $headline);
      document.querySelector('.collapse__close')?.remove();
    }
  };

  getConsentCookie(name) {
    const value = `;${document.cookie}`;
    const parts = value.split(`;${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  }

  init() {
    if (this.getConsentCookie(this.config.consentCookieName) === 'accept') {
      this.hasGlobalConsent = true;
    }
    if (!this.hasGlobalConsent) {
      this.initOverlay();
    } else {
      this.consent();
    }
  }

  initOverlay(create = true) {
    if (!this.$el) {
      const $overlays = document.querySelectorAll('.js-overlay');
      $overlays.forEach(($overlay) => {
        // remove overlay
        if ($overlay && $overlay.parentNode && !create) {
          $overlay.parentNode.removeChild($overlay, $overlay.parentNode);
        }
      });
    } else if (this.$el) {
      const $overlayCurrent = this.$el.querySelector('.js-overlay');
      if ($overlayCurrent) {
        $overlayCurrent.parentNode.removeChild(
          $overlayCurrent,
          $overlayCurrent.parentNode
        );
      }
    }

    if (this.$template && create) {
      // insert overlay from template
      const $clone = document.importNode(this.$template.content, true);
      this.$template = this.$el.querySelector('.js-overlay-template');
      if (this.$template.parentNode) {
        this.$template.parentNode.appendChild($clone);
      }

      // add button / checkbox events
      this.$decline = this.$el.querySelector('.js-overlay-decline');
      this.$consent = this.$el.querySelector('.js-overlay-consent');
      this.cookieName = this.$el.querySelector('.js-overlay-global-consent');

      this.setOverlaySize();

      window.addEventListener('resize', () => {
        this.setOverlaySize();
      });

      if (this.$decline) {
        this.$decline.addEventListener('click', this.declineConsent);
      }

      if (this.$consent) {
        this.$consent.addEventListener('click', this.consent);
      }

      const $openOverlay = this.$el.querySelector('.js-overlay');
      if ($openOverlay) {
        $openOverlay
          .querySelector('.overlay__headline')
          .setAttribute('tabindex', '0');
      }

      if (this.config.onOverlayInit) {
        this.config.onOverlayInit();
      }
    }
  }

  destroy() {
    this.initOverlay(false);
  }

  declineConsent = (event) => {
    if (event) {
      event.stopPropagation();
    }
    if (this.config.onDecline) {
      this.config.onDecline();
    }
    this.initOverlay(false);
  };

  consent = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const hasGlobalConsentOption = this.$el.querySelector('.checkbox__input');
    const hasCheckedGlobalConsent =
      hasGlobalConsentOption &&
      this.$el.querySelector('.checkbox__input').checked;

    if (hasGlobalConsentOption && hasCheckedGlobalConsent) {
      // If global consent is checked, then add cookie
      Cookies.set(this.config.consentCookieName, 'accept', { path: '/' });
      this.hasGlobalConsent = true;
      if (this.config.onGlobalConsent) {
        this.config.onGlobalConsent();
      }
    } else if (this.config.onConsent) {
      this.config.onConsent(event);
    }

    // Close overlay on consent
    this.initOverlay(false);
  };
}
